import { createFileRoute } from '@tanstack/react-router';
import { CartStep } from '../steps/CartStep.js';

export const Route = createFileRoute('/_planner/cart')({
  component: CartStep,
});
